import React from "react";
import { Link, useLocation, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { observer } from "mobx-react";

import classNames from "classnames";
import EventViewStore from "@state/stores/offer/event/EventViewStore";

import { BackButton } from ".";

import { RemoveEventButton } from ".";
import { buildRoute } from "@utils/common/buildOfferRoute";
import { TSection } from "@data-types/offer/live/Section";

export const EmptyOfferMessage = observer(function EmptyOfferMessage({
	store,
}: {
	store: EventViewStore;
}) {
	const { t } = useTranslation();
	const location = useLocation();
	const { culture, period, section } = useParams<{
		culture: string;
		period: string;
		section: TSection;
	}>();
	const isLiveRoute = location.pathname.includes("live");

	const iconClassNames = classNames(
		"card--empty__icon u-icon u-icon--huge u-icon--empty",
		{
			"u-icon--empty--live-betting": isLiveRoute,
			"u-icon--empty--sports-betting": !isLiveRoute,
		}
	);

	const isMultiEvent =
		(store.multiEventViewStore?.eventsViewMap?.size || 1) > 1;
	const redirect = isLiveRoute
		? buildRoute.live({ culture, section })
		: buildRoute.prematch({ culture, period });
	return (
		<div className="container container--empty">
			<div className="card">
				<div className="card__header">
					{isMultiEvent ? (
						<RemoveEventButton store={store} />
					) : (
						<BackButton />
					)}
				</div>
				<div className="card__body">
					<div className="card--empty card--empty--borderless u-mar--bottom--reset">
						<div className="card--empty__content">
							<i className={iconClassNames} />
							<div className="card--empty__title">
								{t<string>("EVENT.EMPTY_STATE.TITLE")}
							</div>
							<div className="card--empty__message">
								{t<string>("EVENT.EMPTY_STATE.DESCRIPTION")}
							</div>
							<Link
								to={redirect}
								className="card--empty__btn btn btn--sml btn--primary--inverted btn--icon btn--animate-forward"
							>
								{t("EVENT.EMPTY_STATE.CTA_LABEL")}
								<i className="u-icon u-icon--tny u-icon--arrow-right" />
							</Link>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
});
